module.exports = __webpack_public_path__ + "assets/images/profiles/1970-3.jpg?v=142392ca";